import { render, staticRenderFns } from "./TabsUnderlineV2.vue?vue&type=template&id=6b05922e&scoped=true"
import script from "./TabsUnderlineV2.vue?vue&type=script&lang=ts"
export * from "./TabsUnderlineV2.vue?vue&type=script&lang=ts"
import style0 from "./TabsUnderlineV2.vue?vue&type=style&index=0&id=6b05922e&lang=scss&scoped=true"
import style1 from "./TabsUnderlineV2.vue?vue&type=style&index=1&id=6b05922e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05922e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b05922e')) {
      api.createRecord('6b05922e', component.options)
    } else {
      api.reload('6b05922e', component.options)
    }
    module.hot.accept("./TabsUnderlineV2.vue?vue&type=template&id=6b05922e&scoped=true", function () {
      api.rerender('6b05922e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/TabsUnderlineV2.vue"
export default component.exports